export default __webpack_public_path__ + "static/media/alert-icon-banner.5f7db71f.svg";